module.exports = __webpack_public_path__ + "img/qrcode.8b936616.jpg";